import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
interface CreateTermineSubmitButtonProps {
  variant?: 'sheet' | 'drawer';
}

export function CreateTermineSubmitButton({
  variant = 'sheet',
}: CreateTermineSubmitButtonProps) {
  const { t } = useTranslation();
  const { loading, onSubmit } = useCreateTermineFormContext();

  if (variant === 'drawer') {
    return (
      <Button
        variant="ghost-primary"
        type="button"
        onClick={onSubmit}
        size="sm"
        disabled={loading}>
        {loading && (
          <>
            <FontAwesomeIcon icon={faSpinnerThird} spin />
            {t('actions.loading')}
          </>
        )}
        {t('domain.termine.sheet.fields.fertig')}
      </Button>
    );
  }

  return (
    <Button
      variant="default"
      type="button"
      onClick={onSubmit}
      className="flex items-center gap-2"
      disabled={loading}>
      {loading ? (
        <>
          <FontAwesomeIcon icon={faSpinnerThird} spin />
          {t('actions.loading')}
        </>
      ) : (
        t('domain.termine.sheet.fields.fertig')
      )}
    </Button>
  );
}
